export default __webpack_public_path__ + "static/media/img-mwa-4-mobile.88dfc767.png";